module.exports = __webpack_public_path__ + "static/media/card2_1.c5551a72.png";